import { useEffect, useRef } from "react";

/**
 * Phase 3.3 — set the document <title> and restore it on unmount.
 * Format: titles passed in are the leaf — we prefix with "Full Spectrum Center · " here
 * so callers don't repeat the brand. Pass an empty/null title to reset.
 */
export function useDocumentTitle(title) {
  const prevRef = useRef(null);
  useEffect(() => {
    if (prevRef.current === null) prevRef.current = document.title || "Full Spectrum Center";
    if (title && typeof title === "string") {
      document.title = `Full Spectrum Center · ${title}`;
    } else {
      document.title = "Full Spectrum Center";
    }
    return () => {
      if (prevRef.current) document.title = prevRef.current;
    };
  }, [title]);
}

export default useDocumentTitle;
